<template lang="pug">
  b-row.mb-5
    b-col
      router-view(@address-changed='reloadAccountsPanel')
</template>

<script>
export default {
  name: 'manager-accounts-address',
  methods: {
    reloadAccountsPanel() {
      this.$parent.$refs.accountsPanel.panelReload()
    },
  },
}
</script>
